import { EnvironmentConfigPatch } from 'src/config/types';
import { getEnv } from 'src/server/lib/getEnv';

const cdnHost = 'https://mosaic01.ztat.net/pgs/cms/';

export default (): EnvironmentConfigPatch => ({
    environment: 'production',
    clusterSuffix: 'zlounge.zalan.do',
    credentialsPath: '/meta/credentials',
    webpackManifest: '../../../assets/production/manifest.json',
    cdnHost,
    services: {
        contentful: 'https://pegasus-contentful-proxy.zlounge.zalan.do',
        tracking: 'https://pegasus-tracking-live.zlounge.zalan.do',
        onboarding_sdk: 'https://zl-acquire-production.ztat.net/sdk/master-6/sdk.js',
        octopusService: 'https://assignment-service.economics.zalan.do',
        sentry: 'https://8665a31652084e6aa0cde147ddb5c7cf@sentry.stups.zalan.do/2479',
    },
    timings: {
        contentRenderingThrottling: 30000,
    },
    contentful: {
        spaceToken: getEnv('CONTENTFUL_TOKEN'),
        spaceId: 'gscn32h7ckds',
        host: 'pegasus-contentful-proxy.zlounge.zalan.do',
    },
    url: {
        assetsBase: cdnHost,
        items: 'https://img01.ztat.net/article/',
    },
    enable: {
        sentry: true,
    },
});
